import { createModule } from "saga-slice";
import { all, call, put, takeLatest } from "redux-saga/effects";
import stockService from "../services/stockService";
const initialState = {
    stocks: [],
    loading: false,
    error: null,
    totalElements: 0, // Total number of records
    totalPages: 0, // Total number of pages
    pageNumber: 0, // Current page number
    pageSize: 10, // Size of each page
};

const stockSlice = createModule({
    name: 'stock',
    initialState,
    reducers: {
        addStock: (state) => {
            state.loading = true;
        },
        search: (state) => {
            state.loading = true;
        },
        updateStock: (state) => {
            state.loading = true;
        },
        transferStock: (state) => {
            state.loading = true;
        },
        uploadStocks: (state, action) => {
            state.loading = true;
        },

        deleteStock: (state, action) => {
            state.loading = true;
        },
        adjustStock: (state) => {
            state.loading = true;
        },
        listStocks: (state) => {
            state.loading = true;
        },
        getMouvements: (state) => {
            state.loading = true;
        },
        fetchedData: (state, payload) => {
            state.loading = false;
            state.stocks = payload;
        },

        finishFetching: (state) => {
            state.isFetching = false;
        },
        fetchError: (state, action) => {
            state.loading = false;
            state.error = action || "An error occurred";
        },
    },
    sagas: (A) => ({
        *[A.search]({ payload }) {
            try {
                console.log(payload);
                const { data } = yield call(stockService.search, payload);
                yield put(A.finishFetching());
                yield put(A.fetchedData(data));
            } catch (e) {
                console.log(e);
                yield put(A.finishFetching());
                yield put(A.fetchError());
            }
        },
        *[A.listStocks]({ payload }) {
            try {
                const { data } = yield call(stockService.listStocks, payload);
                yield put(A.finishFetching());
                yield put(A.fetchedData(data));
            } catch (e) {
                console.log(e);
                yield put(A.finishFetching());
                yield put(A.fetchError());
            }
        },
        *[A.uploadStocks]({ payload }) {
            try {
                yield call(stockService.upload, payload);
                yield put(A.finishFetching());
                yield call(payload.onSuccess);
            } catch (e) {
                console.log(e);
                yield put(A.finishFetching());
                yield put(A.fetchError());
            }
        },
        *[A.transferStock]({ payload }) {
           try {
                yield call(stockService.transferStock, payload.data);
                yield put(A.finishFetching());
                yield call(payload.onSuccess);

            } catch (e) {
                console.log(e);
                yield put(A.finishFetching());
                yield put(A.fetchError());
            }
        },
        *[A.adjustStock]({ payload }) {
            try {
                const { data } = yield call(stockService.adjustStock, payload.data);
                yield put(A.finishFetching());
                yield call(payload.onSuccess);
            } catch (e) {
                console.log(e);
                yield put(A.finishFetching());
                yield put(A.fetchError());
            }
        },

        *[A.updateStock]({ payload }) {
            try {
                const { data } = yield call(stockService.update, payload.data);
                yield put(A.finishFetching());
                yield call(payload.onSuccess);

            } catch (e) {
                console.log(e);
                yield put(A.finishFetching());
                yield put(A.fetchError());
            }
        },
        *[A.deleteStock]({ payload }) {
            try {
                const { data } = yield call(stockService.delete, payload.id);
                yield put(A.finishFetching());
                yield call(payload.onSuccess);
            } catch (e) {
                console.log(e);
                yield put(A.finishFetching());
                yield put(A.fetchError());
            }
        },
        *[A.getMouvements]({ payload }) {
            try {
                const { data } = yield call(stockService.getMouvements, payload);
                yield put(A.finishFetching());
                yield put(A.fetchedData(data));
            } catch (e) {
                console.log(e);
                yield put(A.finishFetching());
                yield put(A.fetchError(e?.response?.data || "Erreur lors du chargement des mouvements"));
            }
        }
    }),

});

export default stockSlice;
export const stockActions = stockSlice.actions;

